// Add your custom JS here.
$ = jQuery;

function viewport() {
    var e = window, a = 'inner';
    if (!('innerWidth' in window )) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    return e[ a+'Width' ];
}
(function ($) {
    $(document).ready(function () {
       /* $("body").on("click", ".dashicons-search.mega-menu-link", function() {
            setTimeout(function(){
                $('input#form-search-input').focus();
            },200);
        });*/


        $('body').on('click', '#show-hide-filter-form', function () {
            if($("#show-hide-filter-form").html() == "Zwiń filtry <i class=\"fa fa-chevron-up fa-lg\" aria-hidden=\"true\"></i>"){
                $("#show-hide-filter-form").html("Rozwiń filtry <i class=\"fa fa-chevron-down fa-lg\" aria-hidden=\"true\"></i>");
            } else {
                $("#show-hide-filter-form").html("Zwiń filtry <i class=\"fa fa-chevron-up fa-lg\" aria-hidden=\"true\"></i>");
            }
        });

        //todo uncomment KM
       /* jQuery('.input-daterange, #data_podjecia_od, #data_podjecia_do').datepicker({
            format: "dd.mm.yyyy",
            language: "pl"
        });*/

        $('input#data_podjecia_do').on('change', function() {
            //    var from = $(this).val().split(".");
            //  var f = new Date(from[2]-1, from[1] - 1, from[0]);
            //  f = f.toString('dd-MM-yy');
            //   $("input#data_podjecia_od").val(f);
        });

        //$("#toggle-register").css("height","0");

        $('.collapse')
            .on('shown.bs.collapse', function() {
                $(this)
                    .parent()
                    .find(".fa-chevron-down.reg")
                    .removeClass("fa-chevron-down")
                    .addClass("fa-chevron-up");
            })
            .on('hidden.bs.collapse', function() {
                $(this)
                    .parent()
                    .find(".fa-chevron-up.reg")
                    .removeClass("fa-chevron-up")
                    .addClass("fa-chevron-down");
            });

        /*
        jQuery('.nktp-download-attachment-table .fa-chevron-down').click(function (event) {
            jQuery('.fa-chevron-up').addClass('fa-chevron-down').removeClass('fa-chevron-up');
            jQuery(this).addClass('fa-chevron-up').removeClass('fa-chevron-down');
        });
        */

        /*BEGIN Klikalny wiersz jeżeli wystąpi w nim link */
       /* $("table:not('[class*=nktp-download-attachment-table]') tr").click( function() {
            let linktr = $(this).find('a').not('.blank').attr('href');
            if(linktr != undefined) {
                window.location = linktr;}
        });
        $("table:not('[class*=nktp-download-attachment-table]') tr").hover( function() {
            let linktr = $(this).find('a').not('.blank').attr('href');
            if(linktr != undefined) {
                $(this).css("cursor","pointer");
                $(this).toggleClass('hover');
            }
        });*/

        var contenTypeFields = $('.content-type-fields');  //ukrywanie pola jeśli jest puste
        if(contenTypeFields.text() == '')  contenTypeFields.hide();
    });
    /* END Klikalny wiersz jeżeli wystąpi w nim link*/


    /*if (viewport() <= 768){
        $('td:contains("Szczegóły")').hide();
        $('th.details').hide();

    }*/
    /* BEGIN Zmniejszenie paddingu w tabelach przy rozdzielczości mniejszej od 960 */
    window.addEventListener("resize", function(){
        if (viewport()  <= 960) {
            $("table").addClass("table-sm");

        }
        else {
            $("table").removeClass("table-sm");
        }
        if (viewport() <= 768){

            $('td:contains("Szczegóły")').hide();
            $('th.details').hide();
        }
        else {
            $('td:contains("Szczegóły")').show();
            $('th.details').show();
        }

    });
    /* END Zmniejszenie paddingu w tabelach przy rozdzielczości mniejszej od 960 */

})(jQuery);

$(document).ready(function(){
    $(window).scroll(function(){
        if($(this).scrollTop()>100){
            $('.scrollToTop').fadeIn();
        }else{$('.scrollToTop').fadeOut();}
    });
    $('.scrollToTop').click(function(){
        if ($(window).innerWidth() > 734)
            $('html, body').animate({scrollTop:0},800);
        else
            window.scrollTo(0, 0);
        return false;
    });


    if($('.mega-current-menu-ancestor').length > 0) {
        $('#nk-breadcrumbs').append('<li><a href="/">Strona główna</a></li>');
    }

    $('.mega-current-menu-ancestor').each(function(key, val){
        $('#nk-breadcrumbs').append('<li><span aria-hidden="true" class="separator">»</span>' + ' <span>' + $(this).children('a').html() + '</span></li>');
        console.log($(this).children('a').attr('href'));
        //console.log($(this).children('a').html());
    });


    //zamiana kolejności Przewodniczący na samą górę
    $('.subcategory-list').eq(0).prepend($('.cat-item-174'))

    try {
        $('#form-search-input').off('keyup');
        $('#form-search-input').off('keydown');
    } catch (e) {

    }


    //zmiana filtrowania projekty akrów prawnych

    $('.content-types-filter-form').on('change', 'select#rodzaj', function () {
        if($(this).val() === '62') {
            $('select#status').val(15);
        }
    });

    function set_projects_filters() {
        $('input#data_podjecia_od').prop('disabled', true);
        $('input#data_podjecia_do').prop('disabled', true);
        $('input#nr_aktu').prop('disabled', true);
        if($('select#sortby').val() === 'data_podjecia' || $('select#sortby').val() === 'nr_aktu'){
            $('select#sortby').val('data_dodania');
        }
        $('select#sortby > option').each(function(){
            if($(this).val() === 'data_podjecia' || $(this).val() === 'nr_aktu'){
                $(this).prop('disabled', true);
            }
        });
    }

    function disable_projects_filters() {
        $('input#data_podjecia_od').prop('disabled', false);
        $('input#data_podjecia_do').prop('disabled', false);
        $('input#data_podjecia_do').prop('disabled', false);
        $('input#nr_aktu').prop('disabled', false);
        $('select#sortby > option').prop('disabled', false);
    }

    if($('select#status').val() === '15') {
        set_projects_filters();
    }

    $('.content-types-filter-form').on('change', 'select#status', function () {
        if($(this).val() === '15') {
            set_projects_filters();
        } else {
            disable_projects_filters();
        }
    });

});


